import { createCRUDHook } from './createCRUDHook';
import { PartDrawingLinkVersionDto, PartDrawingLinksDto } from 'utils/models';
import {
  GET_LATEST_VERSION_BY_PART_ID,
  NEED_TO_CREATE_NEW_VERSION,
  TBL_PART_DRAWING_LINK_VERSION,
  TBL_PARTS,
  GET_PART_DRAWING_LINKS,
} from './apiEndPoints';

interface PartDrawingLinkVersionCustomOperations {
  getLatestVersionByPartId: (partId: number) => Promise<number>;
  needToCreateNewVersion: (partId: number) => Promise<boolean>;
  getPartDrawingLinks: (partId: number) => Promise<PartDrawingLinksDto>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  PartDrawingLinkVersionDto,
  PartDrawingLinkVersionDto,
  PartDrawingLinkVersionCustomOperations
>({
  entityName: 'PartDrawingLinkVersion',
  endpoint: TBL_PART_DRAWING_LINK_VERSION,

  customOperations: (auth) => ({
    getLatestVersionByPartId: async (partId: number): Promise<number> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_PART_DRAWING_LINK_VERSION +
            GET_LATEST_VERSION_BY_PART_ID +
            `?partId=${partId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    needToCreateNewVersion: async (partId: number): Promise<boolean> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TBL_PART_DRAWING_LINK_VERSION +
            NEED_TO_CREATE_NEW_VERSION +
            `?partId=${partId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    getPartDrawingLinks: async (
      partId: number
    ): Promise<PartDrawingLinksDto> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          `${TBL_PARTS}${GET_PART_DRAWING_LINKS}/${partId}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const PartDrawingLinkVersionContext = Context;
export const usePartDrawingLinkVersionManager = useManager;
export const usePartDrawingLinkVersion = useConsumer;
